import React from 'react';
import {Drawer} from 'devextreme-react';
import SideBarItems from "./SideBarItems";
import {inject, observer} from "mobx-react";

function SideBarDrawer(props) {

    const {DataStore} = props;
    const {openDrawer} = DataStore

    return (
        <div className="sidebar-control">
            <Drawer opened={openDrawer} openedStateMode={'shrink'} position={"left"} revealMode={"expand"}
                    component={SideBarItems} height={'100%'} minSize={0}>
            </Drawer>
        </div>
    )
}

export default (inject('DataStore'))(observer(SideBarDrawer))
